// extracted by css-extract-rspack-plugin
export default {"BannerContainer":"qGJ6z","BannerBody":"E8nwY"};